import { render, staticRenderFns } from "./sidemenu.vue?vue&type=template&id=73d2b2d8&"
import script from "./sidemenu.vue?vue&type=script&lang=js&"
export * from "./sidemenu.vue?vue&type=script&lang=js&"
import style0 from "./sidemenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports